// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2hwhg","col":"styles_col__3XfUN"};